// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3t_Wv","author":"Table_author__eeu0h","authorImage":"Table_authorImage__rqF3D","unreadRow":"Table_unreadRow__2tiio"};